import {
  makeResetStyles,
  shorthands,
} from '@fluentui/react-components';

export const useExampleImageStyles = makeResetStyles({
  position: 'relative',
  width: '100%',
  height: '100%',
  '& .example-image': {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    '& .cell-image-frame': {
      ...shorthands.borderRadius('6px'),
      overflow: 'hidden',
    },
  },
});
